import React from 'react'
import { Row, Col,Button }  from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'

function JudgmentResolvedItem({judgment}) {

    const download_judgmentResolved = (sent_id) =>{
        
        window.open(`/sentence-view/${sent_id}`,'_blank');
        
    }
    
  return (
    <Row key={judgment.sent_id}>
        <Col className='shadow p-4 m-2 mb-4 bg-white' sm="12" md="12" lg="12" xl="12" xxl="12">
                                
            <Row className='pb-2 border-bottom'>
                
                <Col xm='6' sm='6' md='4' lg='2' xl='3' xxl='2'> 
                    <p className='position-relative mt-3'>
                        <span className='position-absolute' style={{top:"-17px",fontSize:"15px"}}>N° </span>
                        <strong> {judgment.number}</strong>
                    </p>
                </Col>

                <Col xm='6' sm='6' md='4' lg='3' xl='3' xxl='2'>
                    <p className='position-relative mt-3'>
                    <span className='position-absolute' style={{top:"-17px",fontSize:"15px"}}>Fecha:</span> 
                        <strong>{judgment.date}</strong>
                    </p>
                </Col>

                <Col xm='6' sm='6' md='4' lg='3' xl='3' xxl='2'>
                    <p className='position-relative mt-3'>
                        <span className='position-absolute' style={{top:"-17px",fontSize:"15px"}}>Municipio:</span> 
                        <strong>{judgment.municipality}</strong>
                    </p>
                </Col>

                <Col xm='6' sm='6' md='6' lg='4' xl='3' xxl='2'>
                    <p className='position-relative mt-3'>
                        <span className='position-absolute' style={{top:"-17px",fontSize:"15px"}}>Código:</span>
                        <strong>{judgment.sent_id}</strong>
                    </p>
                </Col>


                <Col xm='12' sm='12' md='6' lg='6' xl='6' xxl='2'>
                    <p className='position-relative mt-3'>
                        <span className='position-absolute' style={{top:"-17px",fontSize:"15px"}}>Materia:</span> 
                        <strong>{judgment.matter}</strong>
                    </p>
                </Col>

                <Col xm='12' sm='12' md='12' lg='6' xl="6" xxl='2'>
                    <p className='position-relative mt-3'>
                        <span className='position-absolute' style={{top:"-17px",fontSize:"15px"}}>Juzgado:</span> 
                        <strong>{judgment.judged}</strong>
                    </p>
                </Col>
                
           
            </Row>

            <Row className='pt-2 border-bottom'>
                {/* <Button variant='danger' className='mb-2' onClick={()=>download_judgmentResolved(judgment.sent_id)}>
                    <FontAwesomeIcon icon={faFilePdf} /> Descargar PDF
                </Button> */}

                <p style={{textAlign:"justify",overflow:"auto"}}>{judgment.resume.trim()}</p>
            </Row>

            <Row>
                <Col className='mt-2' sm="12" md="12" lg="12" xl="12" xxl="12">
                   <h5>Acción/Delito</h5>
                </Col>
                <Col sm="12" md="12" lg="12" xl="12" xxl="12">
                    <Row>
                        <Col sm="12" md="12" lg="12" xl="12" xxl="12" hidden={judgment.crimes.length === 0}>

                            {
                                
                                judgment.crimes.map((crime,index) =>{
                                    return (<p key={index} className='rounded p-1 shadow-sm bg-light text-lowercase'>{crime}</p>);
                                })

                            }

                        </Col>

                        <Col sm="12" md="12" lg="12" xl="12" xxl="12" hidden={judgment.crimes.length > 0}>

                            <p>S/D</p>

                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className='justify-content-center mt-1'>
                <Col xs='6' md='6' lg='6' xxl='6'>
                    <Button variant='danger' className='mb-2 mt-2 w-100' onClick={()=>download_judgmentResolved(judgment.sent_id)}>
                        <FontAwesomeIcon icon={faFilePdf} /> Abrir Sentencia
                    </Button>
                </Col>
                
            </Row>
        </Col>
    </Row>
    
  )
}

export default JudgmentResolvedItem